import { createReducer, on } from '@ngrx/store';
import { licenseActions } from '../actions/license.actions';
import { License } from '../models';

export interface LicenseState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    license: License | null;
}

export const initialState: LicenseState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    license: null,
};

export const licenseReducer = createReducer(
    initialState,
    // Get
    on(licenseActions.getLicense, (state): LicenseState => ({
        ...state,
        loading: true,
        loaded: null,
        error: null,
    })),
    on(licenseActions.getLicenseSuccess, (state, { payload }): LicenseState => ({
        ...state,
        loading: false,
        loaded: true,
        error: null,
        license: payload,
    })),
    on(licenseActions.getLicenseError, (state, payload): LicenseState => ({
        ...state,
        loading: false,
        loaded: false,
        error: payload.code,
    })),
    // Update
    on(licenseActions.updateLicense, (state): LicenseState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(licenseActions.updateLicenseSuccess, (state, { payload }): LicenseState => ({
        ...state,
        saving: false,
        saved: true,
        license: payload,
    })),
    on(licenseActions.updateLicenseError, (state): LicenseState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Upgrade
    on(licenseActions.upgradeLicense, (state): LicenseState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(licenseActions.upgradeLicenseSuccess, (state, { payload }): LicenseState => ({
        ...state,
        saving: false,
        saved: true,
        license: payload,
    })),
    on(licenseActions.upgradeLicenseError, (state): LicenseState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Clear
    on(licenseActions.clear, (): LicenseState => ({ ...initialState })),
);
